import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateService } from "../../api/apiServices";
import parseError from "../../utils/parseError";

const useUpdateService = () => {
    const queryClient = useQueryClient();

    const {
        mutate: editService,
        isPending: isUpdate,
    } = useMutation({
        mutationFn: ({ id, req }) => updateService(req, id),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update service");
        },
    });

    return {
        editService,
        isUpdate,
    };
};

export default useUpdateService;
